import endMailListLoadDatapoint from "./endMailListLoadDatapoint";
import getMailListLoadErrorStatus from "./getMailListLoadErrorStatus";
import { getStore as getListViewStore, isPriorityView, type MailFolderTableQuery } from "owa-mail-list-store";
import { logPrioritizeTelemetryEvent } from "owa-copilot-telemetry/lib/prioritizeTelemetryLogger";
import { getMailboxInfo } from "owa-mail-mailboxinfo";
import { isPrioritizeOnDeliveryOn } from "owa-copilot-settings-utils";
import { getUserStore, setViewOpenedContextMutator } from "owa-mail-priority-inbox-store";
import { addPASKeyMetric } from "owa-performance";

export default function onMailListLoaded(componentRendered: string, tableViewId: string, loadId?: number): void {
    const tableView = getListViewStore().tableViews.get(tableViewId) ?? null;
    
    // When the mail list resolved to an error state, end the datapoint with the mapped
    // error status (ServerError/ClientError) instead of the default success status.
    // Derived from the table's loadErrorStatus.
    const overrideStatus = tableView
        ? getMailListLoadErrorStatus(tableView.loadErrorStatus)
        : undefined;
    
    // PAS only records the first write, so this captures when the boot mail list first painted
    // rows ('VML') or a legitimately empty list ('EmptyML'), excluding error/offline states.
    if (overrideStatus === undefined && componentRendered !== "EmptyML_Error") {
        addPASKeyMetric("MailAppLoadSucceeded");
    }
    
    endMailListLoadDatapoint(componentRendered, tableViewId, loadId, false /* shouldInvalidate */, overrideStatus);
    
    if (!tableView || !isPriorityView(tableView.tableQuery as MailFolderTableQuery)) {
        return;
    }
    
    const mailboxInfo = getMailboxInfo(tableView);
    const viewOpenedContext = getUserStore(mailboxInfo).viewOpenedContext;
    if (!viewOpenedContext) {
        // No pending context — this load wasn't triggered by enterPriorityView
        // (e.g. an unexpected mount path). Skip to avoid logging without attribution.
        return;
    }
    
    logPrioritizeTelemetryEvent("PrioritizeViewOpened", mailboxInfo, {
        // source + prioritizeRunId come from viewOpenedContext (snapshotted at
        // enterPriorityView time) so they stay consistent with openMethod.
        isPrioritizeOnDeliveryOn: isPrioritizeOnDeliveryOn(mailboxInfo),
        ...viewOpenedContext,
    });
    setViewOpenedContextMutator(mailboxInfo, undefined);
}
